// Root module
export const UPDATE_USER_INFO = "UPDATE_USER_INFO"
export const UPDATE_STATISTICS = "UPDATE_STATISTICS"
export const UPDATE_IS_RESTARTING = "UPDATE_IS_RESTARTING"

// Socket module
export const SOCKET_ONOPEN = "SOCKET_ONOPEN"
export const SOCKET_ONCLOSE = "SOCKET_ONCLOSE"
export const SOCKET_RECONNECT = "SOCKET_RECONNECT"
export const SOCKET_ONERROR = "SOCKET_ONERROR"
export const SOCKET_RECONNECT_ERROR = "SOCKET_RECONNECT_ERROR"
export const SOCKET_ONMESSAGE = "SOCKET_ONMESSAGE"
export const SOCKET_DISPATCHER_CONNECTED = "SOCKET_DISPATCHER_CONNECTED"
export const SOCKET_DISPATCHER_RECONNECTING = "SOCKET_DISPATCHER_RECONNECTING"
export const SOCKET_DISPATCHER_DISCONNECTED = "SOCKET_DISPATCHER_DISCONNECTED"
export const SOCKET_SUBSCRIBED = "SOCKET_SUBSCRIBED"
export const SOCKET_UNSUBSCRIBED = "SOCKET_UNSUBSCRIBED"
export const SOCKET_ON_LOGGING = "SOCKET_ON_LOGGING"

// UAcsLogin module
export const UPDATE_FORM_USER_NAME = "UPDATE_FORM_USER_NAME"
export const UPDATE_FORM_USER_PASS = "UPDATE_FORM_USER_PASS"
export const UPDATE_FORM_CHECK = "UPDATE_FORM_CHECK"

// Dashboard module
export const UPDATE_DASHBOARD_TOTAL_VENUE = "UPDATE_DASHBOARD_TOTAL_VENUE"
export const UPDATE_DASHBOARD_TOTAL_ONLINE_BOX =
    "UPDATE_DASHBOARD_TOTAL_ONLINE_BOX"
export const UPDATE_DASHBOARD_TOTAL_OFFLINE_BOX =
    "UPDATE_DASHBOARD_TOTAL_OFFLINE_BOX"
export const UPDATE_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX =
    "UPDATE_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX"

// Company module
export const LOAD_COMPANY_LIST = "LOAD_COMPANY_LIST"

// Country module
export const LOAD_COUNTRY_LIST = "LOAD_COUNTRY_"

// Market module
export const LOAD_MARKET_LIST = "LOAD_MARKET_LIST"
export const ADD_NEW_MARKET = "ADD_NEW_MARKET"
export const UPDATE_SELECTED_MARKET = "UPDATE_SELECTED_MARKET"
export const CLEAR_MARKET_LIST = "CLEAR_MARKET_LIST"
export const CLEAR_SELECTED_MARKET = "CLEAR_SELECTED_MARKET"

// Venue module
export const LOAD_VENUE_LIST = "LOAD_VENUE_LIST"
export const ADD_NEW_VENUE = "ADD_NEW_VENUE"
export const DELETE_VENUE = "DELETE_VENUE"
export const UPDATE_VENUE = "UPDATE_VENUE"
export const UPDATE_SELECTED_VENUE = "UPDATE_SELECTED_VENUE"
export const CLEAR_SELECTED_VENUE = "CLEAR_SELECTED_VENUE"
export const CLEAR_VENUE_LIST = "CLEAR_VENUE_LIST"

// SmartBox module
export const LOAD_SMARTBOX_LIST = "LOAD_SMARTBOX_LIST"
export const LOAD_OPERATION_LOG_LIST = "LOAD_OPERATION_LOG_LIST"
export const LOAD_FUZZY_SEARCH_RESULT_LIST = "LOAD_FUZZY_SEARCH_RESULT_LIST"
export const ADD_NEW_SMART_BOX = "ADD_NEW_SMART_BOX"
export const UPDATE_SELECTED_SMART_BOX_LIST = "UPDATE_SELECTED_SMART_BOX_LIST"
export const UPDATE_FUZZY_SEARCH_PARAMETER = "UPDATE_FUZZY_SEARCH_PARAMETER"
export const APPEND_OPERATION_LOG = "APPEND_OPERATION_LOG"
export const CLEAR_SMART_BOX_LIST = "CLEAR_SMART_BOX_LIST"
export const CLEAR_SELECTED_SMART_BOX_LIST = "CLEAR_SELECTED_SMART_BOX_LIST"
export const CLEAR_OPERATION_LOG_LIST = "CLEAR_OPERATION_LOG_LIST"
export const CLEAR_FUZZY_SEARCH_RESULT_MAP = "CLEAR_FUZZY_SEARCH_RESULT_MAP"
export const CLEAR_FUZZY_SEARCH_PARAMETER = "CLEAR_FUZZY_SEARCH_PARAMETER"

// Version module
export const UPDATE_GATEWAY_VERSION_LIST = "UPDATE_GATEWAY_VERSION_LIST"
export const UPDATE_SBLDRIVE_VERSION_LIST = "UPDATE_SBLDRIVE_VERSION_LIST"

// TimeRange module
export const EDIT_DATE_TIME_RANGE = "EDIT_DATE_TIME_RANGE"
